import React from 'react';
import { connect } from 'react-redux';
import Slider from 'react-rangeslider';
import { isNotLogin } from '../../../helpers/Common';
import { callApiSystemSetting, REDUCER_NAME } from '../../sidebar/reducer';
import { changeUIFontSize, saveFontSize } from './../../../helpers/FontSize';
import { changeFontSize } from './../../../app/reducer';
import { FONTSIZE } from './../../../../configs/LayoutConfig';
import './font-size.scss';
import 'react-rangeslider/lib/index.css';

const MAP_FONT_SIZE = {
  0: FONTSIZE.SMALL,
  1: FONTSIZE.MEDIUM,
  2: FONTSIZE.LARGE,
};

const MAP_FONT_SIZE_TO_VALUE = {
  [FONTSIZE.SMALL]: 0,
  [FONTSIZE.MEDIUM]: 1,
  [FONTSIZE.LARGE]: 2,
};

class FontSize extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: MAP_FONT_SIZE_TO_VALUE[props.fontSize],
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { fontSize } = this.props;
    if (fontSize !== nextProps.fontSize) {
      this.setState({
        value: MAP_FONT_SIZE_TO_VALUE[nextProps.fontSize],
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { fontSize } = this.props;

    if (fontSize !== prevProps.fontSize) {
      changeUIFontSize(fontSize);
      saveFontSize(fontSize);
    }
  }

  handleChange = value => {
    const {
      changeFontSize,
      dataSystem,
      callApiSystemSetting,
      user,
    } = this.props;
    this.setState({
      value,
    });
    if (this.fontSize !== value) {
      this.fontSize = value;
      if (!isNotLogin(user)) {
        callApiSystemSetting({
          ...dataSystem,
          fontSize: value,
        });
      }
    }
    changeFontSize(MAP_FONT_SIZE[value]);
  };

  render() {
    const { value } = this.state;

    return (
      <div
        className="slider font-size-wrapper d-flex align-items-center"
        style={{ width: 75 }}
      >
        <div className="mr-5 text-left-size text-pointer">A</div>
        <Slider
          min={0}
          max={2}
          step={1}
          tooltip={false}
          value={value}
          onChange={this.handleChange}
        />
        <div className="ml-5 text-right-size text-pointer">A</div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    fontSize: state.fontSize,
    dataSystem: state[REDUCER_NAME].settingSystem.dataSystem,
    user: state.userInfo,
  };
};

const mapDispatchToProps = {
  changeFontSize,
  callApiSystemSetting,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FontSize);
